//
// Generated by @himenon/openapi-typescript-code-generator v0.27.4
//
// OpenApi : 3.0.0
//
//
import {
  Params$AdminCompanyFileController_findAll,
  Response$AdminCompanyFileController_findAll$Status$200,
  ResponseContentType$AdminCompanyFileController_findAll,
} from '@api-client/generated/client';
import { QueryOptions, useApiClient } from '@hooks/useApiClient';

export const useAdminCompanyFileController_findAll = (options: {
  params: Params$AdminCompanyFileController_findAll['parameter'];
  config?: QueryOptions<
    Response$AdminCompanyFileController_findAll$Status$200[ResponseContentType$AdminCompanyFileController_findAll]
  >;
}) =>
  useApiClient<
    Params$AdminCompanyFileController_findAll,
    Response$AdminCompanyFileController_findAll$Status$200[ResponseContentType$AdminCompanyFileController_findAll]
  >({
    method: 'AdminCompanyFileController_findAll',
    params: { parameter: options.params },
    config: options.config,
  });
